<template>
  <div class="products">
    <div class="container">
      <h1 class="text-center">{{thisproduct.no}}-{{thisproduct.productName}}</h1>
      <div class="d-flex row m-auto" style="max-width:1440px">
        <div class="slideshow col-12 col-md-6">
          <slideshow :pictures="thisproduct.pictures"/>
        </div>
        <div class="description col-12 col-md-6">
          <h2 class="text-justify">
            規格簡述：
            <br />
            {{thisproduct.description}}
          </h2>
          <div class="txt">
            <div v-for="(item, index) in thisproduct.componentList" :key="index">
              <p>{{item.component}}</p>
              <ul v-for="(item, index) in item.spec" :key="index">
                <li>{{item}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="dm-btn">
        <a :href="thisproduct.DMdownload" class="btn DMdownload" @click.prevent="download">
          DM下載
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import slideshow from '@/components/products_slideshow.vue';

export default {
  components: {
    slideshow,
  },
  props: {
    product: {
      type: Object,
      default: () => ({
        no: 1,
        DMdownload: '',
        productName: '',
        description: '',
        componentList: [
          {
            component: '',
            spec: [],
          },
        ],
        pictures: [],
      }),
    },
  },
  data() {
    return {
      thisproduct: this.product,
    };
  },
  methods: {
    download() {
      // eslint-disable-next-line no-alert
      window.alert('DM尚未上傳');
    },
  },
};
</script>

<style lang="scss" scoped>
.products {
  margin: 50px 0;
  h1 {
    font-size: 2rem;
    padding: 30px 0;
    margin: 0;
  }
  .slideshow {
    width: 50%;
    padding: 10px;
  }
  .description {
    width: 50%;
    padding: 10px;
    font-size: 0.9rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h2 {
        font-size: 0.9rem;
      }
    .txt {
      height: 300px; // try overflow
      overflow: auto; // try overflow
      background-color: rgba(224, 224, 224, 0.5); // try overflow
      padding: 10px; // try overflow
      p {
        margin: 0;
        // margin-top: 10px;
      }
      ul {
        // padding: 0;
        // list-style-position: inside;
        margin: 0;
      }
    }
  }
  .dm-btn {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 10px;
    .btn {
      padding: 5px 30px;
      font-size: 1rem;
      .fas {
        padding-right: 10px;
      }
    }
    .DMdownload{
      // background-color: #2684b3bc;
      background-color: #DD6439;
      color: #fff;
    }
    .DMdownload:hover{
      opacity: 0.9;
    }
  }
}
</style>
